import React, { useState, useEffect, useRef } from "react";
import { downloadCsv } from "../common/sharedFunctions";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams,useLocation } from "react-router-dom";
import moment from 'moment/min/moment-with-locales';
import { colors } from "../components/Theme/WebTheme";
import AlertDialog from "../components/AlertDialog";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Switch from "@mui/material/Switch";
import { Chip, Typography } from "@mui/material";
import {MAIN_COLOR,SECONDORY_COLOR} from "../common/sharedFunctions"
import { safeLabel, textOrDash, userFullName } from "../common/adminDisplay";
import EditIcon from '@mui/icons-material/Edit';
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import BlankTable from '../components/Table/BlankTable';
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';
import EmailIcon from '@mui/icons-material/Email';
import EmailComposer from "../components/EmailComposer";
import { formatAdminMoney, getSettlementStyle, withVtcSettlements } from "../common/adminFinance";

export default function Users() {
  const navigate = useNavigate();
  const {id} = useParams();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    editUser,
    deleteUser,
    fetchUsersOnce,
  } = api;
  const [data, setData] = useState([]);
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const auth = useSelector((state) => state.auth);
  const settings = useSelector((state) => state.settingsdata.settings);
  const bookings = useSelector((state) => state.bookinglistdata.bookings || []);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const [role, setRole] = useState(null);
  const [fleetAdminsObj, setFleetAdminsObj] = useState();
  const [sortedData, SetSortedData] = useState([]);
  const {state} = useLocation()
  const [currentPage,setCurrentPage] = useState(null)

  useEffect(()=>{
    setCurrentPage(state?.pageNo)
  },[state])
  
  const HandalePageChange = (page)=>{
    setCurrentPage(page)
  }

  useEffect(() => {
    dispatch(fetchUsersOnce());
  }, [dispatch, fetchUsersOnce]);

  useEffect(() => {
    if (staticusers) {
      if (role === "admin") {
        let arr = staticusers.filter((user) => user.usertype === "fleetadmin");
        let obj = {};
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          let user = arr[i];
          arr2.push({
            id: user.id,
            desc:
              userFullName(user) +
              " (" +
              textOrDash(user.mobile) +
              ") " +
              textOrDash(user.email),
          });
          obj[user.id] =
            userFullName(user) +
            " (" +
            textOrDash(user.mobile) +
            ") " +
            textOrDash(user.email);
        }
        setFleetAdminsObj(obj);
      }
      setTimeout(() => {
        setData(
          staticusers.filter(
            (user) =>
              user.usertype === "driver" &&
              ((user.fleetadmin === auth.profile.uid &&
                auth.profile.usertype === "fleetadmin") ||
                auth.profile.usertype === "admin")
          )
        );
      }, 1000);
    } else {
      setData([]);
    }
    loaded.current = true;
  }, [
    staticusers,
    auth.profile.usertype,
    auth.profile.uid,
    settings.AllowCriticalEditsAdmin,
    role,t
  ]);

  useEffect(()=>{
    if(data){
      SetSortedData(withVtcSettlements([...data], bookings).sort((a,b)=>(moment(b.createdAt) - moment(a.createdAt))))
    }
  },[data, bookings])

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

 
  const handelApproved = (rowData) => {
    const updatedUser = { ...rowData, approved: !rowData.approved, adminApprovedTrue:true,  };

    dispatch(editUser(updatedUser.id, updatedUser));
    dispatch(fetchUsersOnce());
    return updatedUser;
  };
  const handelDriverActiveStatus = (rowData) => {
    const updatedUser = {
      ...rowData,
      driverActiveStatus: !rowData.driverActiveStatus,
    };

    dispatch(editUser(updatedUser.id, updatedUser));
    dispatch(fetchUsersOnce());
    return updatedUser;
  };

  const columns = [
    { title: t('createdAt'), field: 'createdAt', editable:'never', defaultSort:'desc',render: rowData => rowData.createdAt? moment(rowData.createdAt).format('lll'):null,},

    { title: safeLabel(t, "first_name", "Prénom"), field: "firstName", initialEditValue: "", render: rowData => textOrDash(rowData.firstName) },
    { title: safeLabel(t, "last_name", "Nom de famille"), field: "lastName", initialEditValue: "", render: rowData => textOrDash(rowData.lastName) },
    {
      title: safeLabel(t, "mobile", "Numéro de portable"),
      field: "mobile",
      editable: "onAdd",
      render: (rowData) => textOrDash(rowData.mobile),
    },
    {
      title: safeLabel(t, "email", "E-mail"),
      field: "email",
      editable: "onAdd",
      render: (rowData) => textOrDash(rowData.email),
      headerStyle: { textAlign: "center" },
    },
    {
      title: safeLabel(t, "profile_image", "Image de profil"),
      field: "profile_image",
      render: (rowData) =>
        rowData.profile_image ? (
          <img
            alt="Profile"
            src={rowData.profile_image}
            style={{ width: 40, height: 40, borderRadius: "50%" }}
          />
        ) : (
          <AccountCircleIcon sx={{ fontSize: 40 }} />
        ),
      editable: "never",
    },
    {
      title: safeLabel(t, "account_approve", "Compte approuvé"),
      field: "approved",
      type: "boolean",
      render: (rowData) => (
        <Switch
          disabled={!settings.AllowCriticalEditsAdmin}
          checked={rowData.approved}
          onChange={() => handelApproved(rowData)}
        />
      ),
    },
    {
      title: safeLabel(t, "driver_active", "Chauffeur actif"),
      field: "driverActiveStatus",
      editable: "never",
      type: "boolean",
      render: (rowData) => (
        <Switch
          disabled
          checked={rowData.driverActiveStatus}
          onChange={() => handelDriverActiveStatus(rowData)}
        />
      ),
    },
    {
      title: safeLabel(t, "queue", "File d'attente"),
      field: "queue",
      editable: "never",
      type: "boolean",
      initialEditValue: true,
      render: (rowData) => (
        <Switch
          disabled
          checked={rowData.queue}
          onChange={() => console.log(rowData.queue)}
        />
      ),
    },
    {
      title: 'Règlement',
      field: 'settlementBalance',
      type: 'numeric',
      defaultSort: 'asc',
      editable: 'never',
      customSort: (a, b) => Number(a.settlementBalance || 0) - Number(b.settlementBalance || 0),
      render: rowData => {
        const style = getSettlementStyle(rowData.settlementBalance);
        const amount = rowData.settlementBalance < 0 ? Math.abs(rowData.settlementBalance) : rowData.settlementBalance;
        return (
          <Chip
            size="small"
            label={`${rowData.settlementLabel} ${formatAdminMoney(amount, settings)}`}
            sx={{ color: style.color, backgroundColor: style.backgroundColor, border: `1px solid ${style.borderColor}`, fontWeight: 900 }}
          />
        );
      }
    },
    { title: 'Il doit Allô Driver', field: 'driverOwesAmount', type: 'numeric', editable: 'never', render: rowData => formatAdminMoney(rowData.driverOwesAmount, settings) },
    { title: 'À payer chauffeur', field: 'platformOwesAmount', type: 'numeric', editable: 'never', render: rowData => formatAdminMoney(rowData.platformOwesAmount, settings) },
    { title: 'Commission générée', field: 'accountingCommissionAmount', type: 'numeric', editable: 'never', render: rowData => formatAdminMoney(rowData.accountingCommissionAmount, settings) },
    { title: 'CA courses', field: 'accountingGrossAmount', type: 'numeric', editable: 'never', render: rowData => formatAdminMoney(rowData.accountingGrossAmount, settings) },
    { title: 'Courses compta', field: 'accountingRideCount', type: 'numeric', editable: 'never' },
    { title: 'Dernière activité compta', field: 'accountingLastActivity', editable: 'never', render: rowData => rowData.accountingLastActivity ? moment(rowData.accountingLastActivity).format('lll') : '-' }
  ];

  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };


  const [selectedRow, setSelectedRow] = useState(null);
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);

  return !loaded.current ? (
    <CircularLoading />
  ) : (
    <div style={{ backgroundColor: colors.LandingPage_Background }}>
      <ThemeProvider theme={theme}>
      {sortedData?.length >0 ? 
        <MaterialTable
          title={t("drivers_title")}
          columns={columns}
          onChangePage={(page)=>HandalePageChange(page)}
          style={{
            direction: isRTL === "rtl" ? "rtl" : "ltr",
            borderRadius: "8px",
            boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
            padding: "20px",
          }}
          data={sortedData}
          onRowClick={(evt, selectedRow) =>
            setSelectedRow(selectedRow.tableData.id)
          }
          options={{
            initialPage:state?.pageNo,
            exportCsv: (columns, data) => {
              let hArray = [];
              const headerRow = columns.map((col) => {
                if (typeof col.title === "object") {
                  return col.title.props.text;
                }
                hArray.push(col.field);
                return col.title;
              });
              const dataRows = data.map(({ tableData, ...row }) => {
                row.createdAt =
                  new Date(row.createdAt).toLocaleDateString() +
                  " " +
                  new Date(row.createdAt).toLocaleTimeString();
                row.fleetadmin = row.fleetadmin
                  ? fleetAdminsObj[row.fleetadmin]
                  : "";
                let dArr = [];
                for (let i = 0; i < hArray.length; i++) {
                  dArr.push(row[hArray[i]]);
                }
                return Object.values(dArr);
              });
              const { exportDelimiter } = ",";
              const delimiter = exportDelimiter ? exportDelimiter : ",";
              const csvContent = [headerRow, ...dataRows]
                .map((e) => e.join(delimiter))
                .join("\n");
              const csvFileName = "download.csv";
              downloadCsv(csvContent, csvFileName);
            },
            exportButton: {
              csv: settings.AllowCriticalEditsAdmin,
              pdf: false,
            },
            maxColumnSort: "all_columns",
            rowStyle: (rowData) => ({
              backgroundColor:
                selectedRow === rowData.tableData.id ? colors.ROW_SELECTED :colors.WHITE
            }),
            ...TableStyle()
          }}
          localization={localization(t)}
          editable={{
            onRowUpdate: (newData, oldData) =>
              settings.AllowCriticalEditsAdmin || role === "admin"
                ? new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      dispatch(editUser(oldData.id, newData));
                      dispatch(fetchUsersOnce());
                    }, 600);
                  })
                : new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      alert(t("demo_mode"));
                    }, 600);
                  }),
            onRowDelete: (oldData) =>
              settings.AllowCriticalEditsAdmin || role === "admin"
                ? new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      dispatch(deleteUser(oldData.id));
                      dispatch(fetchUsersOnce());
                    }, 600);
                  })
                : new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      alert(t("demo_mode"));
                    }, 600);
                  }),
          }}
          actions={[
            {
              icon: "add",
              tooltip: t("add_driver"),
              isFreeAction: true,
              onClick: (event) => navigate("/users/edituser/driver",{state:{pageNo:currentPage}}),
            },
            (rowData) => ({
              tooltip: t("edit"),
              icon: () => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginRight:0
                }}
              >
                <EditIcon style={{ color: MAIN_COLOR }} />  
              </div>
            ),
            onClick: (event, rowData) =>{
              navigate(`/users/edituser/driver/${rowData.id}`,{state:{pageNo:currentPage}})
            }
          }),
            {
              icon: "info",
              tooltip: t("profile_page_subtitle"),
              onClick: (event, rowData) => {
                navigate(`/users/driverdetails/${rowData.id}`,{state:{pageNo:currentPage}});
              },
            },
            (rowData) => ({
              icon: () => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    padding: 10,
                    backgroundColor: MAIN_COLOR,
                    borderRadius: 5,
                  }}
                >
                  <Typography style={{ color: colors.WHITE, fontWeight: 700 }}>
                    {safeLabel(t, "documents", "Documents")}
                  </Typography>
                </div>
              ),
              tooltip: safeLabel(t, "documents", "Documents"),
              onClick: () => navigate(`/users/userdocuments/${id}/${rowData.id}`,{state:{pageNo:currentPage}}),
            }),
            (rowData) => ({
              icon: () => <EmailIcon />,
              tooltip: t('send_email') || 'Send Email',
              onClick: () => {
                if (rowData.email) {
                  setSelectedEmails([rowData.email]);
                  setEmailDialogOpen(true);
                } else {
                  setCommonAlert({ open: true, msg: t('no_email_available') || 'No email available for this user' });
                }
              }
            }),
          ]}
        />
        :  <BlankTable title={t('drivers_title')}  columns={columns} 
      actions={[
        {
          icon: "add",
          tooltip: t("add_driver"),
          isFreeAction: true,
          onClick: (event) => navigate("/users/edituser/driver"),
        },
      ]}
      data={[]} localization={localization(t)} options={TableStyle()}/>}
        </ThemeProvider>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
      <EmailComposer 
        open={emailDialogOpen} 
        onClose={() => setEmailDialogOpen(false)}
        recipients={selectedEmails}
        userType="driver"
      />
    </div>
  );
}
